import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-pattern-list-item',
  templateUrl: './pattern-list-item.component.html',
  styleUrls: ['./pattern-list-item.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class PatternListItemComponent implements OnInit {
  @Input() sewingPattern;

  constructor() { }

  ngOnInit() {
    console.log(this.sewingPattern);
  }

}
